<template>
  <!-- 单点登录阅卷 -->
  <div class="external_view_PaperTestAudit">
    <PaperTest v-if="show"
               :autoid="autoid"
               :mautoid="mautoid"
               :empid="empid"
               :paperid="paperid"
               :teststyle="teststyle"
               :ispass="ispass"
               :hasyj="hasyj"
               :username='username'
               @refreshData='refreshData'></PaperTest>
  </div>
</template>

<script>
import { getSsoPaperTestAuditInfo } from "@api/wxpx.js";
import PaperTest from './paperTest'
export default {
  components: {
    PaperTest
  },
  data () {
    let guid = this.$route.query.guid || '21bcf7f6731840578255ceda826c85bd'
    return {
      guid,
      username: '',
      paperid: 0,
      mautoid: 0,
      autoid: 0,
      empid: 0,
      teststyle: '',
      ispass: false,
      hasyj: false,
      show: false,
    }
  },
  created () {
    this.getSsoPaperTestAuditInfoData()
  },
  methods: {
    // 获取问卷的单点登录数据
    getSsoPaperTestAuditInfoData () {
      getSsoPaperTestAuditInfo({
        guid: this.guid
      }).then(res => {
        if (res.data.length > 0)
        {
          this.mautoid = res.data[0].autoid
          this.username = res.data[0].username
          this.paperid = res.data[0].paperid
          this.autoid = res.data[0].autoid
          this.empid = res.data[0].empid
          this.teststyle = res.data[0].teststyle
          this.ispass = res.data[0].ispass
          this.hasyj = res.data[0].hasyj
          this.show = true
        }
      })
    },
    // 刷新数据
    refreshData () {
      this.getSsoPaperTestAuditInfoData()
    }
  }

}
</script>

<style lang="less" scoped>
.external_view_PaperTestAudit {
  width: 100%;
  height: 100%;
  // overflow: auto;
}
</style>